export default {
  "content": "<path d=\"M10.5 12.5a1 1 0 011 1V20h-2v-4.086l-6.293 6.293-1.414-1.414L8.086 14.5H4v-2h6.5zM22.207 3.207L15.914 9.5H20v2h-6.5a1 1 0 01-1-1V4h2v4.086l6.293-6.293 1.414 1.414z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};